/**
 * The unique Symbol for the key property.
 */
export const KeySymbol = Symbol('key')
